import { useLocalObservable } from 'mobx-react-lite';

import { ICommonPopupsProps } from '@gem/popups';

import Tasks from 'APP/Tasks';
import { ApplicationTheme } from 'APP/constants/appearance';
import { TChatBackground } from 'APP/store/Appearance/Appearance.types';
import Entities from 'STORE';

interface IAppearanceSettingsPopupPresenter {
  activeTheme: ApplicationTheme | null;
  activeChatBackground: TChatBackground;
  hasBackButton: boolean;
  onThemeChange(theme: ApplicationTheme | null): void;
  onChatBackgroundChange(chatBackground: TChatBackground): void;
  onClose(): void;
  onBack(): void;
}

export function useAppearanceSettingsPopupPresenter({
  popupInstance,
  onClose,
  onBack,
}: ICommonPopupsProps): IAppearanceSettingsPopupPresenter {
  const presenter = useLocalObservable<IAppearanceSettingsPopupPresenter>(() => ({
    get activeTheme(): ApplicationTheme | null {
      return Entities.appearance.activeTheme;
    },

    get activeChatBackground(): TChatBackground {
      return Entities.appearance.getChatBackgroundForEntity(null);
    },

    get hasBackButton(): boolean {
      return !!onBack;
    },

    onThemeChange(theme: ApplicationTheme | null): void {
      Tasks.appearance.setTheme(theme);
    },

    onChatBackgroundChange(chatBackground: TChatBackground): void {
      Tasks.appearance.setGlobalChatBackground(chatBackground);
    },

    onClose(): void {
      popupInstance.close();
      onClose?.();
    },

    onBack(): void {
      popupInstance.close();
      onBack?.();
    },
  }));

  return presenter;
}
